import { useEffect, useRef, useState } from "react";
import { Field } from "./field.tsx";

/** Gõ đúng mã dự án để xác nhận thay đổi CRITICAL. Báo `onMatchChange(true)` chỉ khi khớp CHÍNH XÁC. */
export function ConfirmByTyping({ expected, label, hint, onMatchChange }: { expected: string; label: string; hint: string; onMatchChange: (matched: boolean, typed: string) => void }) {
  const [typed, setTyped] = useState("");
  const ref = useRef<HTMLInputElement>(null);
  useEffect(() => ref.current?.focus(), []);
  return (
    <Field
      ref={ref}
      label={label}
      hint={hint}
      autoComplete="off"
      spellCheck={false}
      value={typed}
      onChange={(e) => {
        setTyped(e.target.value);
        onMatchChange(e.target.value === expected, e.target.value);
      }}
    />
  );
}
